import { z } from "zod"

import { parseShopifyReferencesFromMetatield } from "~/lib/shopify/utils/parse-references-from-metafields"

export const globalAssociatedProductsMetaobjectSchema = z.object({
  products: z.string().transform(parseShopifyReferencesFromMetatield),
})

export type TGlobalAssociatedProductsMetaobjectSchema = z.infer<typeof globalAssociatedProductsMetaobjectSchema>
